import { defineAsyncComponent } from 'vue'
export default {
  debug: defineAsyncComponent(() => import("/home/userapp/layouts/debug.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/home/userapp/layouts/error.vue").then(m => m.default || m))
}